import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ApprenticeSupervisorForm } from "../../../components/apprenticeSupervisor/ApprenticeSupervisorForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { ApprenticeSupervisor } from "../../../models/apprenticeSupervisor";
import type { Company } from "../../../models/company";
import { apprentice_supervisors_path } from "../../../routes";

type ApprenticeSupervisorCreateProps = {
  apprenticeSupervisor: Partial<ApprenticeSupervisor>;
  companies: Company[];
};

export default function ApprenticeSupervisorCreate({ apprenticeSupervisor, companies }: ApprenticeSupervisorCreateProps) {
  const { pathWithYearContext } = useYearContext();

  const newApprenticeSupervisor = (values: RequestPayload) => router.post(pathWithYearContext(apprentice_supervisors_path), values);

  return (
    <ContentShell title="Neuer Berufsbildner/in" onBack={() => router.get(pathWithYearContext(apprentice_supervisors_path))}>
      <ApprenticeSupervisorForm
        apprenticeSupervisor={apprenticeSupervisor}
        companies={companies}
        submitButtonLabel="Erstellen"
        onSubmit={newApprenticeSupervisor}
      />
    </ContentShell>
  );
}
